import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { OpsUser } from 'icreate/common/models/ops-user';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OpsUserService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId: string) {
        return await lastValueFrom(
            this.http.get(`${this.domain}/api/opsUsers`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(opsUserData) {
        return await lastValueFrom(
            this.http.post<OpsUser>(`${this.domain}/api/opsUser`, opsUserData, {
                headers: this.headers,
            })
        );
    }

    async update(opsUserData) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/opsUser/${opsUserData.id}`, opsUserData, {
                headers: this.headers,
            })
        );
    }

    async delete(opsUserId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/opsUser/${opsUserId}`));
    }

    async setSessionTimeout(timeout: number, vesselId) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/opsUser/sessionTimeout`,
                { sessionTimeout: timeout, vesselId },
                {
                    headers: this.headers,
                }
            )
        );
    }
}
